import React from 'react';
import { object, array, bool } from 'prop-types';
import { NamedLink } from '../../components';
import FeaturedSellersCarousel from './FeaturedSellersCarousel';
import JudaicaCollectionsCarousel from './JudaicaCollectionsCarousel';
import FeaturedProductsCarousel from './FeaturedProductsCarousel'

const JudaicaSection = ({
  judaicaCollectionsSection,
  featuredJudaicaListings,
  featuredJudaicaListingsInProgress,
  featuredJudaicaListingsError,
  judaicaCategoryArtists,
  judaicaCategoryArtistsInProgress,
  judaicaCategoryArtistsError,
  currentUser
}) => {
  return (
    <section id="judaica" className="py-12">
      <div className="max-w-7xl mx-auto rounded-3xl md:p-8 md:bg-[var(--colorJudaica)]/5">

        {/* Section Header */}
        <div className="flex items-center gap-3 mb-12 border-b border-black opacity-100 mx-4">
          <h2 className="text-3xl sm:text-4xl pb-3 lg:text-4xl font-bold text-black font-['Be_Vietnam_Pro']">
            Shop Judaica
          </h2>
          <NamedLink
            name="SearchPageWithListingType"
            params={{ listingType: 'judaica' }}
            className="ml-auto px-6 py-2 bg-black text-white font-medium rounded-lg hover:bg-gray-800 transition-colors"
          >
            Browse All →
          </NamedLink>
        </div>


        {/* Content */}
        <div className="space-y-12">

          {/* Featured Judaica Sellers Carousel - now gets data from props */}
          <div>
            <div className="flex flex-col ml-8 mb-4">
              <h2 className="md:text-2xl text-xl font-sbold text-black font-['Be_Vietnam_Pro'] mt-4 mb-0">
                Seller Spotlight
              </h2>
            </div>
            <FeaturedSellersCarousel
              sectionId="judaica-sellers-carousel"
              numColumns={3}
              artistCategory="judaica"
              artists={judaicaCategoryArtists}
              inProgress={judaicaCategoryArtistsInProgress}
              error={judaicaCategoryArtistsError}
            />
          </div>

          {/* Browse Categories */}
          {judaicaCollectionsSection && (
            <div>
              <h3 className="text-lg sm:text-xl font-semibold text-black font-['Be_Vietnam_Pro'] ml-8 mx-4">
                Browse Categories
              </h3>
              <JudaicaCollectionsCarousel
                {...judaicaCollectionsSection}
                sectionId="judaica-collections-carousel"
              />
            </div>
          )}

          {/* Featured Judaica Products Carousel */}
          <div>
            <h3 className="text-lg sm:text-xl font-semibold text-black font-['Be_Vietnam_Pro'] ml-8 mx-4">
              Featured Judaica
            </h3>
            <FeaturedProductsCarousel
              featuredListings={featuredJudaicaListings}
              inProgress={featuredJudaicaListingsInProgress}
              error={featuredJudaicaListingsError}
              currentUser={currentUser}
              id="judaica-featured-products-carousel"
            />
          </div>

        </div>

      </div>
    </section>
  );
};

JudaicaSection.propTypes = {
  judaicaCollectionsSection: object,
  featuredJudaicaListings: array,
  featuredJudaicaListingsInProgress: bool,
  featuredJudaicaListingsError: object,
  judaicaCategoryArtists: array,
  judaicaCategoryArtistsInProgress: bool,
  judaicaCategoryArtistsError: object,
  currentUser: object,
};

export default JudaicaSection; 